// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
} from 'common.data';

// Global Enums
import {
  RegattaStatus,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Input,
  InputGroup,
  NavItem,
  NavLink,
} from 'reactstrap';

// Types
import type {
  $ReducerState,
} from '../../../../redux';
import type {
  $OpenActiveRegattaPageAction,
  $SetActiveRegattaIdAction,
} from '../../../../redux/modules/main/actions';

export type $OwnProps = $Translate;

export type $StateProps = {
  main: $ReducerState<'main'>;
};

export type $DispatchProps = {
  openActiveRegattaPage: $OpenActiveRegattaPageAction;
  setActiveRegattaId: $SetActiveRegattaIdAction;
};

type $Props = $DispatchProps & $OwnProps & $StateProps;

const regattaStatusSymbol: Record<RegattaStatus, string> = {
  [RegattaStatus.canceled]: '✕',
  [RegattaStatus.ended]: '●',
  [RegattaStatus.new]: '◎',
  [RegattaStatus.ongoing]: '◑',
  [RegattaStatus.upcoming]: '○',
};

const LeftButtonsView = function ({
  main,
  openActiveRegattaPage,
  setActiveRegattaId,
  t,
}: $Props) {
  return (
    <>
      <NavItem className={'d-flex align-items-center regatta-select-input-wrapper'}>
        <InputGroup className={'regatta-select-input'}>
          <div className={'input-group-prepend'}>
            <span className={'input-group-text'}>
              <em className={'icon-flag'} />
            </span>
          </div>
          <Input
            id={'regatta'}
            name={'regatta'}
            onChange={async (e) => {
              await setActiveRegattaId({
                RegattaId: e.target.value,
              });
            }}
            title={t('Active regatta')}
            type={'select'}
            value={main.activeRegattaId || undefined}
          >
            {main.activeRegattaId === null && (
              <option
                selected={main.activeRegattaId === null}
              />
            )}
            {main.regattas.map((regatta: $Model<'Regatta'>) => (
              <option
                key={regatta.id}
                value={regatta.id}
              >
                {`${regatta.Public ? regattaStatusSymbol[regatta.Status] : '◌'} ${regatta.Name}`}
              </option>
            ))}
          </Input>
          <NavLink
            className={'regatta-page-button d-flex align-items-center btn btn-outline-secondary input-group-append bg-lightgrey py-2 px-3'}
            onClick={() => openActiveRegattaPage()}
          >
            <em className={'font-header-icon icon-link my-1'} />
            <span className={'d-none d-lg-inline ml-2'}>
              {t('Regatta page')}
            </span>
          </NavLink>
        </InputGroup>
      </NavItem>
      <NavItem className={'regatta-page-button-wrapper ml-2'} />
    </>
  );
};

export default LeftButtonsView;
